export default __webpack_public_path__ + "static/video-cover-93fab6c3dda7e048267be9e55cf56cdd.png";